import { Navigate, useLocation } from "react-router";

export function AISchedules() {
  const location = useLocation();
  return <Navigate to={`/home/chat/schedules${location.search}${location.hash}`} replace />;
}
